import React from "react";
import { ColumnsType } from "antd/lib/table";
import { EyeOutlined } from "@ant-design/icons";
import { Button, Table, Tag } from "../../atoms";
import { ICustomerFavorite } from "../../../common/types";
import { EmptyState } from "./Customer.style";

interface ICustomerFavoritesProps {
  favorites: ICustomerFavorite[];
  loading?: boolean;
  onPreview?: (favorite: ICustomerFavorite) => void;
}

const typeTag: Record<string, string> = {
  PACKAGE: "Πακέτο",
  HOTEL: "Ξενοδοχείο",
};

const formatAmount = (value?: number, currency = "EUR") =>
  typeof value === "number"
    ? new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency,
      }).format(value)
    : "—";

export const CustomerFavorites: React.FC<ICustomerFavoritesProps> = ({
  favorites,
  loading,
  onPreview,
}) => {
  const columns: ColumnsType<ICustomerFavorite> = [
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (value: string) => (
        <Tag color={value === "PACKAGE" ? "blue" : "green"}>
          {typeTag[value] || value}
        </Tag>
      ),
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      align: "right",
      render: (amount: number, record) => formatAmount(amount, record.currency),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button
          type="link"
          icon={<EyeOutlined />}
          onClick={() => onPreview?.(record)}
        />
      ),
    },
  ];

  if (!loading && favorites.length === 0) {
    return <EmptyState>Δεν υπάρχουν αγαπημένα</EmptyState>;
  }

  return (
    <Table
      rowKey={(record) => record.id}
      columns={columns}
      dataSource={favorites}
      loading={loading}
      pagination={false}
    />
  );
};
